import React from "react";
import ProductDetail from "../../lib/Pages/ProductDetail";

export default function ProductPage() {
  return <ProductDetail />;
}
